import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1aaba1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "weather" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src"]

import { reactive } from "vue";
import axios from "../../utils/http/axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'weather',
  setup(__props) {

const data: any = reactive({});

goWeather();
/**
 * 获取天气信息
 */
async function goWeather() {
    try {
        // 获取经纬度
        const position: any = await getPosition();
        data.frameUrl = `https://widget-page.qweather.net/h5/index.html?md=013&bg=1&lc=${position.longitude},${position.latitude}&key=7fb5816208334d858a799b3f531c5d14&v=_1641877899474`;
        // console.log(position);

        // 根据经纬度获取具体位置信息
        const address: any = await getAddress(position);
        // console.log(address);

        // 获取天气
        const weather: any = await getWeather(
            address.HeWeather6[0].basic[0].cid
        );
        // console.log(weather);
        data.weatherInfo = {
            address: address.HeWeather6[0].basic[0].location, // 地址
            temperature: weather.now.tmp + "°", // 温度
            weatherImg: `https://widget-s.qweather.net/img/plugin/190516/icon/c/${weather.now.cond_code}d.png`, // 天气图片
            air: weather.air_now_city.qlty // 空气质量
        };
    } catch (err) {
        console.log(err);
    }
}

/**
 * 获取经纬度
 */
function getPosition() {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            // 获取经纬度
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    resolve({
                        // 纬度
                        latitude: position.coords.latitude,
                        // 经度
                        longitude: position.coords.longitude
                    });
                },
                function () {
                    reject(arguments);
                }
            );
        } else {
            reject("你的浏览器不支持当前地理位置信息获取");
        }
    });
}

/**
 * 根据经纬度获取具体位置信息
 */
function getAddress(position: any) {
    return new Promise((resolve, reject) => {
        axios
            .get("https://geoapi.qweather.com/find", {
                params: {
                    key: "7fb5816208334d858a799b3f531c5d14",
                    group: "cn",
                    lang: "zh",
                    location: `${position.longitude},${position.latitude}`
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

/**
 * 根据位置信息获取天气
 */
function getWeather(location: any) {
    return new Promise((resolve, reject) => {
        axios
            .get("https://widget-api.heweather.net/s6/plugin/h5", {
                params: {
                    key: "7fb5816208334d858a799b3f531c5d14",
                    location,
                    lang: "zh"
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (data.weatherInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(data.weatherInfo.address), 1),
          _createElementVNode("p", null, _toDisplayString(data.weatherInfo.temperature), 1),
          _createElementVNode("img", {
            src: data.weatherInfo.weatherImg,
            alt: data.weatherInfo.weatherImg
          }, null, 8, _hoisted_3),
          _createElementVNode("p", null, _toDisplayString(data.weatherInfo.air), 1)
        ]))
      : _createCommentVNode("", true),
    (data.frameUrl)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 1,
          src: data.frameUrl,
          frameborder: "0",
          height: "450px"
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})